// @flow strict-local

export default function prettifyTime(timeInMs: number): string {
  return timeInMs < 1000 ? `${timeInMs}ms` : `${(timeInMs / 1000).toFixed(2)}s`;
}
